<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-home-app-container-detail">
      <div class="ccui-app-container">
        <div class="applicate-communicate">
          <div class="title">
            <el-row>
              <el-col :span="20">
                <div class="title-wuzi">
                  {{ themeData.themeName }}
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <div class="title-Company">
                  {{ themeData.createName }}
                  <span style="color: #ccc">{{
                    themeData.modifieOrgName
                  }}</span>
                </div>
              </el-col>
              <el-col :span="4"
                ><div class="grid-content bg-purple" style="text-align: right;">
                  {{ themeData.createTime }}
                </div></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="24">
                <div class="title-remark" v-html="themeData.content"></div>
              </el-col>
            </el-row>
            <el-row v-if="fileList.length > 0 || detailList.length > 0">
              <el-col :span="24">
                <div class="title-file">
                  <el-row>
                    <el-col :span="22"
                      ><div class="grid-content bg-purple">附件</div></el-col
                    >
                    <el-col :span="2" v-if="fileList.length > 3">
                      <div
                        class="more-show"
                        v-if="moreToShow"
                        @click="showMore"
                      >
                        展开
                      </div>
                      <div
                        class="more-show"
                        v-if="!moreToShow"
                        @click="showLess"
                      >
                        收起
                      </div>
                    </el-col>
                  </el-row>
                  <div
                    class="file-item"
                    v-for="(item, index) in detailList"
                    :key="index"
                  >
                    <el-row>
                      <el-col :span="22"
                        ><div class="grid-content bg-purple">
                          {{ item.fileName }}
                        </div></el-col
                      >
                      <el-col :span="2"
                        ><div @click="download(item)" class="file-upload">
                          下载
                        </div></el-col
                      >
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <div class="operate-btn">
                  <!-- <span class="title-operate">
                        <el-button type="primary">回 复</el-button>
                    </span> -->
                  <span class="title-operate"
                    ><i class="el-icon-view"></i>
                    <span style="color: #3ED161;">
                      {{ themeData.viewCount }}</span
                    ></span
                  >
                  <span class="title-operate"
                    ><i class="el-icon-chat-dot-square"></i>
                    <span style="color: #3ED161;">
                      {{ themeData.replyCount }} </span
                    >条评论</span
                  >
                  <span
                    class="title-operate"
                    v-if="publisher == '1'"
                    @click="titleEdit"
                    ><i class="el-icon-edit"></i> <span>编辑</span></span
                  >
                  <span
                    class="title-operate"
                    v-if="publisher == '1'"
                    @click="themeDel"
                    ><i class="el-icon-delete"></i> <span>删除</span></span
                  >
                  <span
                    class="title-operate"
                    v-if="publisher == '1'"
                    @click="themeclose"
                    ><i class="el-icon-circle-close"></i>
                    <span> {{ isParticipate ? "关闭" : "开启" }}</span></span
                  >
                  <span
                    class="title-operate"
                    v-if="publisher == '1'"
                    @click="themeIsTopping"
                    ><i class="el-icon-top"></i>
                    <span> {{ isTop == 1 ? "取消置顶" : "置顶" }}</span></span
                  >
                  <span
                    class="title-operate"
                    v-if="publisher == '1'"
                    @click="themeIsessence"
                    ><i class="el-icon-star-on"></i>
                    <span>
                      {{ isQuintessence == 1 ? "取消精华" : "精华" }}</span
                    ></span
                  >
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="ccui-app-container-tow" v-if="themeReplierData.length > 0">
        <div class="view-list">
          <div
            class="part-one"
            v-for="(item, index) in themeReplierData"
            :key="index"
          >
            <div class="list-item">
              <el-row>
                <el-col :span="24">
                  <div class="theme">
                    {{ item.createName
                    }}<span style="color: #ccc"> {{ item.createOrgName }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="theme-explain" v-html="item.content"></div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="20">
                  <div class="theme-time">
                    编辑于 <span>{{ item.createTime }}</span>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div
                    style="text-align: right;"
                    class="theme-reply"
                    @click="show_detail(index)"
                  >
                    <i
                      :class="
                        isCollapse ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                      "
                    ></i
                    >{{ item.isShow ? " 收起回复" : " 回复" }}
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-if="item.isShow">
              <div id="list-inner">
                <div class="part-two" v-if="isParticipate">
                  <el-row>
                    <el-col :span="22">
                      <div class="grid-content bg-purple">
                        <el-input
                          @input="onInput()"
                          placeholder="欢迎参与评论"
                          v-model="item.releaseValue"
                          class="input-with-select"
                        />
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content bg-purple-light">
                        <el-button type="primary" @click="releaseBtn(item)">
                          发 布</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="part-three">
                  <div class="comment-list">
                    <div
                      class="comment"
                      :style="
                        item.replyList.length == 0
                          ? ''
                          : 'border-bottom: 1px solid #E8E8E8;'
                      "
                    >
                      <span>{{
                        item.replyList.length >= 5
                          ? item.lineList.length
                          : item.replyList.length
                      }}</span
                      >条评论
                    </div>
                    <div
                      class="content"
                      v-for="(itemOne, indexOne) in item.replyList.length >= 5
                        ? item.lineList
                        : item.replyList"
                      :key="indexOne"
                    >
                      <div class="content-text">
                        <div class="text">{{ itemOne.createName }}</div>
                        <div class="text">{{ itemOne.content }}</div>
                        <div class="text" style="color: #4A4A4A;">
                          {{ itemOne.createTime }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="more"
                    @click="moreBtn(item)"
                    v-if="item.replyList.length >= 5"
                  >
                    点击查看更多评论
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ccui-table-footer">
          <div id="ccui-paging">
            <el-pagination
              :total="pageTotal"
              :page-size="pageSize"
              :current-page="pageNo"
              :page-sizes="[10, 20, 50, 100, 200, 500]"
              background
              layout="total, sizes, prev, pager, next, jumper"
              popper-class="ccui-paging-page-size-popper"
              @prev-click="handlePrev"
              @next-click="handleNext"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
            <el-button
              class="ccui-pagination-btn"
              size="mini"
              type="default"
              @click="handleSizeChange('none')"
              >确定</el-button
            >
          </div>
        </div>
      </div>
      <div v-else class="ccui-app-container-tow-null">
        暂无评论
      </div>
    </div>
    <div class="ccui-app-container-three" v-show="isParticipate">
      <editor
        ref="editor"
        :editorContent="editorContent"
        @change="changeEditor"
        :pageSource="'themeDetails'"
      ></editor>
      <div class="on-submit">
        <el-button type="primary" @click="onSubmit" style="width: 85px;"
          >发 表</el-button
        >
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :title="moreCommentsList.length + '条评论'"
      width="1180px"
      height="638px"
      ref="dialog"
      @before-close="handleClose"
    >
      <span>
        <div class="data-list" ref="dataList" @scroll="handleScroll">
          <div class="scroll-list">
            <div
              v-for="(item, index) in moreCommentsList"
              :key="index"
              class="data-item"
            >
              <div class="content-text">
                <div class="text">{{ item.createName }}</div>
                <div class="text">{{ item.content }}</div>
                <div class="text" style="color: #4A4A4A;">
                  {{ item.createTime }}
                </div>
              </div>
            </div>
            <!-- 分页控件，点击加载更多 -->
          </div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <div class="scroll-input">
          <!-- <el-button
                slot="footer"
                size="small"
                type="text"
                class="load-data"
                @click="loadMore"
                :disabled="loading"
                >加载更多...</el-button
            > -->
          <el-row>
            <el-col :span="22"
              ><div class="grid-content bg-purple">
                <el-input
                  placeholder="请输入内容"
                  v-model="releaseBtnInput"
                  class="input-with-select"
                /></div
            ></el-col>
            <el-col :span="2"
              ><div class="grid-content bg-purple-light">
                <el-button type="primary" @click="releaseSubmit">
                  发 布</el-button
                >
              </div></el-col
            >
          </el-row>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  selectForumTheme,
  qryThemeReplier,
  delThemeByIds,
  saveReplier,
  switchTop,
  switchQuintessence,
  closeOrOpenTheme
} from "@/app/shop/api/shopping";
import { addUrlPerFix } from "@/basa/utils";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb.vue";
import editor from "@/app/shop/components/editor.vue";
export default {
  name: "themeDetails",
  components: {
    baseBreadCrumb,
    editor
  },
  props: {
    source: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      currBreadCrumb: [{ title: "主题详情" }],
      releaseBtnInput: "",
      pageTotal: 10,
      pageNo: 0,
      pageSize: 10,
      dialogVisible: false,
      isCollapse: false,
      isParticipate: false,
      loading: false,
      hasMore: true,
      loadCurrentPage: 1, // 当前页数
      loadPageSize: 10,
      moreCommentsList: [], // 数据列表
      themeReplierData: [],
      themeData: {},
      isQuintessence: 0,
      isTop: 0,
      isClose: 0,
      editorContent: "",
      openId: JSON.parse(localStorage.getItem("loginInfo")).openId,
      publisher: "0",
      fileList: [],
      detailList: []
      // moreToShow: true,
    };
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        console.log(newValue, "dialogVisible");
        console.log(this.$refs.dialog, "dataList");
        // this.$refs.dialog.addEventListener("scroll", this.handleScroll);
      }
    }
  },
  computed: {
    moreToShow: {
      get() {
        return this.fileList.length > this.detailList.length;
      },
      set() {
        return this.fileList.length > this.detailList.length;
      }
    }
  },
  activated() {
    console.log(
      JSON.parse(localStorage.getItem("loginInfo")).openId,
      "loginInfo"
    );
    this.getList();
    this.getQryThemeReplier();
  },
  deactivated() {
    //   if (this.$refs.dataList) {
    //   this.$refs.dataList.removeEventListener("scroll", this.handleScroll);
    // }
  },
  methods: {
    download(row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/pp/oss/downloadByUploadId?uploadId=${row.uploadId}`;
      console.log(openUrl);
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    showMore() {
      this.detailList = this.fileList; // 显示所有数据
      this.moreToShow = false; // 更多按钮隐藏
    },
    showLess() {
      this.detailList = this.fileList.slice(0, 3); // 显示前3条数据
      this.moreToShow = true; // 显示更多按钮
    },
    themeIsessence() {
      let params = {
        businessId: this.$route.query.themeId,
        isShowLoading: true
      };
      switchQuintessence(params).then(res => {
        if (res.data.code == "0") {
          if (this.isQuintessence == 1) {
            this.$message({
              // showClose: true,
              message: "修改成功！",
              type: "success"
            });
            this.isQuintessence = 0;
          } else {
            this.$message({
              // showClose: true,
              message: "修改成功！",
              type: "success"
            });
            this.isQuintessence = 1;
          }

          // this.getQryThemeReplier()
        }
      });
    },
    themeIsTopping() {
      let params = {
        businessId: this.$route.query.themeId,
        isShowLoading: true
      };
      switchTop(params).then(res => {
        if (res.data.code == "0") {
          if (this.isTop == 1) {
            this.$message({
              // showClose: true,
              message: "修改成功！",
              type: "success"
            });
            this.isTop = 0;
          } else {
            this.$message({
              // showClose: true,
              message: "修改成功！",
              type: "success"
            });
            this.isTop = 1;
          }

          // this.getQryThemeReplier()
        }
      });
    },
    onInput() {
      this.$forceUpdate();
    },
    releaseBtn(item) {
      if (item.releaseValue == "") {
        this.$message({
          // showClose: true,
          message: "请输入评论内容！",
          type: "error"
        });
        return false;
      }
      let params = {
        content: item.releaseValue,
        themeId: this.$route.query.themeId,
        replierId: "",
        replierToId: item.replierId,
        basTextinfoId: "",
        isShowLoading: true
      };
      saveReplier(params).then(res => {
        if (res.data.code == "0") {
          this.$message({
            // showClose: true,
            message: "发布成功！",
            type: "success"
          });
          this.getQryThemeReplier();
        }
      });
    },
    releaseSubmit() {
      console.log(this.moreItem, "moreItem");
      let params = {
        content: this.releaseBtnInput,
        themeId: this.$route.query.themeId,
        replierId: "",
        replierToId: this.moreItem.replierId,
        basTextinfoId: "",
        isShowLoading: true
      };
      saveReplier(params).then(res => {
        if (res.data.code == "0") {
          this.$message({
            // showClose: true,
            message: "发布成功！",
            type: "success"
          });
          this.dialogVisible = false;
          this.releaseBtnInput = "";
          this.getQryThemeReplier();
        }
      });
    },
    show_detail(index) {
      // let that = this;
      let listData = this.themeReplierData;
      let isShow = this.themeReplierData[index].isShow; // 先用一个变量接收一个原来的状态值
      listData[index].isShow = !isShow;
      let item = listData[index];
      // console.log(item, 'index')
      this.$set(this.themeReplierData, index, item);
    },
    getList() {
      let params = {
        businessId: this.$route.query.themeId,
        isShowLoading: true
      };
      selectForumTheme(params).then(res => {
        if (res.data.code == "0") {
          this.themeData = res.data.data;
          if (this.themeData.content.indexOf("<img") !== -1) {
            this.themeData.content = this.themeData.content.replace(
              "<img",
              "<img style='width: 100%'"
            );
          }
          this.fileList = JSON.parse(
            JSON.stringify(res.data.data.tbasFileInfoBOList)
          );
          this.detailList = res.data.data.tbasFileInfoBOList.slice(0, 3); // 默认显示前三条数据

          if (this.openId.toString() == this.themeData.createId) {
            this.publisher = "1";
          } else {
            this.publisher = "0";
          }
          this.isParticipate = this.themeData.themeClose == 0 ? true : false;
          (this.isQuintessence = this.themeData.themeIsQuintessence),
            (this.isTop = this.themeData.themeIsTop),
            (this.isClose = this.themeData.themeClose),
            console.log(this.themeData.content, "themeData");
        }
      });
    },
    getQryThemeReplier(val) {
      let params = {
        pageNo: val || 1,
        pageSize: 10,
        sortName: "createDate",
        sortOrder: "desc",
        businessId: this.$route.query.themeId,
        isShowLoading: true
      };
      qryThemeReplier(params).then(res => {
        if (res.data.code == "0") {
          this.themeReplierData = res.data.data.rows;
          console.log(this.themeReplierData, "themeReplierData");
          this.themeReplierData.forEach(item => {
            if (item.replyList.length >= 5) {
              item.lineList = [...item.replyList.slice(0, 5)];
              this.moreCommentsList = [...item.replyList.slice(5)];
            }
          });

          this.themeReplierData.forEach(item => {
            item.isShow = false;
            item.releaseValue = "";
          });
          this.pageNo = res.data.data.pageNo;
          this.pageTotal = res.data.data.recordsTotal;
          console.log(
            this.themeReplierData,
            this.moreCommentsList,
            "themeReplierData"
          );
        }
      });
    },
    // loadMore() {
    //   console.log("调取loadMore方法");
    //   if (!this.hasMore) return;

    //   this.loading = true;
    //   this.loadCurrentPage++;

    //   // 模拟从接口获取数据
    //   this.fetchData(this.loadCurrentPage, this.loadPageSize)
    //     .then(data => {
    //       this.moreCommentsList = this.moreCommentsList.concat(data);
    //       this.loading = false;

    //       // 判断是否还有更多数据
    //       if (data.length < this.loadPageSize) {
    //         this.hasMore = false;
    //       }
    //     })
    //     .catch(error => {
    //       console.error("加载数据失败", error);
    //       this.loading = false;
    //     });
    // },
    // 关闭弹框前的回调
    // handleClose() {
    //   this.moreCommentsList = []; // 清空数据列表
    //   this.loadCurrentPage = 1;
    //   this.hasMore = true;
    //   this.loading = false; // 确保关闭弹框时停止加载
    // },
    // 模拟获取数据的方法
    // fetchData(page, pageSize) {
    //   return new Promise((resolve, reject) => {
    //     // 这里应该是调用你的 API 获取数据
    //     // 以下是一个模拟的数据响应示例
    //     const mockData = new Array(pageSize)
    //       .fill(null)
    //       .map((_, index) => `Item ${(page - 1) * pageSize + index + 1}`);
    //     setTimeout(() => {
    //       resolve(mockData);
    //     }, 1000);
    //   });
    // },
    // 监听滚动事件，当滚动到底部时加载更多数据
    handleScroll(event) {
      // 获取滚动容器的引用
      //   const scrollContainer = event.target || this.$refs.dataList;
      //   // 确保 scrollContainer 是一个有效的 DOM 元素
      //   if (!scrollContainer) return;
      //   // 计算滚动位置
      //   const isAtBottom =
      //     scrollContainer.scrollTop + scrollContainer.clientHeight >=
      //     scrollContainer.scrollHeight - 10;
      //   // 只有在滚动到底部时才调用 loadMore 方法
      //   if (isAtBottom && this.hasMore) {
      //     console.log('zoujinqu')
      //     this.loadMore();
      //   }
      // let scrollTop = e.target.scrollTop;
      // let scrollHeight = e.target.scrollHeight;
      // let offsetHeight = Math.ceil(e.target.getBoundingClientRect().height);
      // let currentHeight = scrollTop + offsetHeight;
      // console.log(currentHeight, scrollHeight, "触底了");
      //  if (currentHeight >= scrollHeight) {
      //       console.log('触底了')
      //      }
      //   const { scrollTop, scrollHeight, clientHeight } = event.target;
      //   if (scrollTop + clientHeight >= scrollHeight - 5 && this.hasMore) { // 留出5px的边距
      //     console.log('zoujinqu')
      //     this.loadMore();
      //   }
    },
    changeEditor(val) {
      this.editorContent = val;
    },
    themeclose() {
      let params = {
        businessId: this.$route.query.themeId
      };
      closeOrOpenTheme(params).then(res => {
        if (res.data.code == "0") {
          this.$message({
            // showClose: true,
            message: "修改成功！",
            type: "success"
          });
          this.isParticipate = !this.isParticipate;
          this.getList();
        }
      });
    },
    onSubmit() {
      if (this.editorContent == "") {
        this.$message({
          showClose: true,
          message: "请输入发表内容！",
          type: "error"
        });
      } else {
        let params = {
          content: this.editorContent,
          themeId: this.$route.query.themeId,
          replierId: "",
          basTextinfoId: "",
          isShowLoading: true
        };
        saveReplier(params).then(res => {
          if (res.data.code == "0") {
            this.$message({
              // showClose: true,
              message: "发表成功！",
              type: "success"
            });
            this.$refs.editor.content = "";
            this.$refs.editor.fileData = [];
            this.getList();
            this.getQryThemeReplier();
          }
        });
      }
    },
    themeReply(index) {
      var that = this;
      var listData = that.themeReplierData;
      var isShow = that.themeReplierData[index].isShow; // 先用一个变量接收一个原来的状态值
      listData[index].isShow = !isShow;
      that.themeReplierData = listData;
      // if (this.isCollapse === index) {
      //     this.isCollapse = null;
      // } else {
      //     this.isCollapse = index;
      // }
    },
    themeDel() {
      let params = {
        id: this.$route.query.themeId,
        isShowLoading: true
      };
      delThemeByIds(params).then(res => {
        if (res.data.code == "0") {
          this.$message({
            // showClose: true,
            message: "主题删除成功！",
            type: "success"
          });
          this.$router.push({
            path: "/announcementsList?source=29&activeIndex=13"
          });
          // this.getList();
        }
      });
    },
    titleEdit() {
      console.log("2222222");
      this.$router.push({
        path: "/postingAdd",
        query: {
          columnId: this.themeData.columnId,
          themeId: this.themeData.themeId,
          title: this.themeData.themeName,
          editorContent: this.themeData.content,
          type: "Edit"
        }
      });
    },
    moreBtn(item) {
      this.dialogVisible = true;
      this.moreItem = item;
    },
    handleClose() {
      this.releaseBtnInput = "";
      this.dialogVisible = false;
    },
    release() {
      this.$router.push({
        path: "/topicReply",
        query: {
          // source: item.source,
          // activeIndex: item.activeIndex
        }
      });
    },
    titleHandle() {
      this.$router.push({
        path: "/postingAdd",
        query: {
          // source: item.source,
          // activeIndex: item.activeIndex
        }
      });
    },
    postingBtn() {
      this.$router.push({
        path: "/postingAdd",
        query: {
          // source: item.source,
          // activeIndex: item.activeIndex
        }
      });
    },
    handlePrev() {
      //   --this.pageNo;
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleNext() {
      //   ++this.pageNo;
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleSizeChange(val) {
      //   this.pageNo = 1;
      //   if (val !== "none") {
      //     this.pageSize = val;
      //     // setSessionItem("pageSize", this.tableName, val);
      //   }
      //   let obj = {
      //     pageNo: this.pageNo,
      //     pageSize: this.pageSize
      //   };
      //   // this.getList(obj);
    },
    handleCurrentChange(val) {
      this.getQryThemeReplier(val);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .img {
  width: 100% !important;
}
/* 修改垂直滚动条 */
::v-deep .view-list::-webkit-scrollbar {
  width: 10px; /* 修改宽度 */
}

/* 修改滚动条轨道背景色 */
::v-deep .view-list::-webkit-scrollbar-track {
  background-color: #ffffff;
}

/* 修改滚动条滑块颜色 */
::v-deep .view-list::-webkit-scrollbar-thumb {
  background-color: #888;
}

/* 修改滚动条滑块悬停时的颜色 */
::v-deep .view-list::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
::v-deep .ccui-home-app-container-detail {
  min-height: 0 !important;
}
::v-deep .editor {
  height: 300px !important;
}
::v-deep .el-dialog__body {
  padding: none !important;
}
::v-deep .scroll-input .el-input__inner {
  height: 47px !important;
  border: none;
}
::v-deep .scroll-input .el-button--primary {
  height: 32px !important;
  width: 76px !important;
  margin-top: 8px;
  margin-right: 15px;
}
::v-deep .part-two .el-input__inner {
  height: 47px !important;
  border: none;
}
::v-deep .part-two .el-button--primary {
  height: 32px !important;
  width: 76px !important;
  margin-top: 8px;
}
::v-deep .el-dialog__body {
  margin-bottom: 15px !important;
  padding: 0px 20px !important;
  // margin-top: 10px !important;
}
.ccui-app-container {
  min-height: 130px;
  //   padding: 24px !important;
}
.ccui-app-container-tow-null {
  width: 1180px;
  height: 652px;
  background: #ffffff;
  line-height: 35;
  color: #999999;
  font-size: 15px;
  text-align: center;
  margin-bottom: 20px;
}
.ccui-app-container-tow {
  height: 660px;
  position: relative;
  background-color: #fff;
  padding: 20px 24px 65px 24px !important;
  margin-bottom: 20px;
  font-size: 13px;

  .view-list {
    height: 650px;
    overflow: auto;
  }
  .part-one:nth-child(1) {
    border-top: none;
  }
  .part-one {
    border-top: 1px solid #e8e8e8;
    padding-top: 20px;
    padding-bottom: 20px;
    .theme-explain {
      padding: 12px 0;
    }
    .theme-time {
      color: #999999;
    }
    .theme-reply {
      margin: 0 20px 0 20px;
      color: #999999;
      cursor: pointer;
    }
    .theme-reply:hover {
      color: #0089ef;
    }
  }
  .part-two {
    // height: 47px;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    margin-top: 28px;
    padding: 0px 14px;
    // margin-bottom: 16px;
    // .release-btn {
    //     text-align: right;
    // }
  }
  .part-three {
    // height: 250px;

    margin-top: 16px;
    // padding: 12px 14px;
    .comment-list {
      border-radius: 2px;
      border: 1px solid #e8e8e8;
      .comment {
        padding: 12px 14px;
      }
      .content {
        padding: 0px 14px 12px 12px;

        .content-text {
          margin: 16px 0;
          font-size: 13px;
          .text {
            margin-bottom: 8px;
          }
        }
      }
    }

    .more {
      color: #999999;
      text-align: center;
      padding: 8px 0 8px 0;
      cursor: pointer;
      border-left: 1px solid #e8e8e8;
      border-right: 1px solid #e8e8e8;
      border-bottom: 1px solid #e8e8e8;
    }
    .more:hover {
      color: #0089ef;
    }
  }
  .part-four {
    border-top: 1px dashed #e8e8e8;
    height: 150px;
    padding-top: 19px;
    margin-top: 29px;
    .text {
      margin-bottom: 16px;
    }
    .explain {
    }
  }
  .ccui-table-footer {
    // position: absolute;
    // left: 60%;
    // bottom: 25px;
    text-align: right;
    margin-top: 20px;
  }
}
.ccui-app-container-three {
  background-color: #fff;
  padding: 24px !important;
  margin-bottom: 20px;
  font-size: 13px;
  .on-submit {
    text-align: right;
    margin-top: 35px;
  }
}
.title {
  .title-wuzi {
    font-weight: 600;
    font-size: 18px;
    color: #4a4a4a;
  }
  .title-Company {
    margin: 5px 0 20px 0;
  }
  .title-remark {
    font-weight: 400;
    font-size: 13px;
    color: #4a4a4a;
    margin-bottom: 10px;
  }
  .title-file {
    margin-bottom: 10px;
    .more-show {
      cursor: pointer;
    }
    .file-item {
      margin-bottom: 5px;
      .file-upload {
        color: #666;
        cursor: pointer;
      }
      .file-upload:hover {
        color: #0089ef;
      }
    }
  }
  .operate-btn {
    .title-operate {
      margin-right: 17px;
      color: #999999;
      cursor: pointer;
    }
    .title-operate:hover {
      color: #0089ef;
    }
  }
}
// .ccui-app-container-tow {
//   position: relative;
//   .ccui-table-footer {
//   position: absolute;
//     left: 60%;
//     bottom: 24px;
// }
// }
.scroll-list {
  height: 500px;
  // margin-bottom: 12px;
  .content-text {
    margin: 16px 0;
    font-size: 13px;
    .text {
      margin-bottom: 8px;
    }
  }
}
.scroll-input {
  border: 1px solid #e8e8e8;
  margin: 12px 0 29px 0;
  position: relative;
  .load-data {
    position: absolute;
    top: -56px;
    left: 50%;
    color: #999999;
  }
}
</style>
